import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useAuthContext } from "./Auth";

export function UseSetLenguajePorPais() {
  const { user } = useAuthContext();
  const { i18n } = useTranslation();

  useEffect(() => {
    if (user?.pais) {
      i18n.changeLanguage(user.pais.toLowerCase()); // Cambia el idioma al código del país
    }
  }, [user, i18n]);
}
